export const consentMainStyle = {
    border: "1px solid #e8e8e8",
    borderRadius: "4px",
    overflow: "auto",
    padding: "8px 24px",
    width: "800px",
    height: "600px"
}